module.exports = __webpack_public_path__ + "static/img/QLD-4.c7dfb01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-4.jpg
// module id = MLDd
// module chunks = 0